import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { PurchaseReturn, PurchaseReturnCreate, PurchaseReturnFilter } from '../data/purchaseReturn';

export function createPurchaseReturnService(client: AxiosInstance) {
  return createCrudService<PurchaseReturn, PurchaseReturnCreate, PurchaseReturnFilter>(
    client,
    '/purchase/PurchaseReturn',
    'id',
  );
}

export type PurchaseReturnService = CrudService<PurchaseReturn, PurchaseReturnCreate, PurchaseReturnFilter>;
